import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

const PackageColumn = ({ packageTypeId = '' }) => {
  const sellerPackages = useSelector(Global.selectSellerPackages) || [];
  if (!packageTypeId) {
    return '';
  }

  const matchingPackage = sellerPackages.find((sellerPackage) => sellerPackage.packageTypeId === packageTypeId);
  if (!matchingPackage) {
    return '';
  }
  return matchingPackage.name;
};

PackageColumn.propTypes = {
  packageTypeId: PropTypes.string,
};

export default PackageColumn;
